// eslint-disable-next-line import/prefer-default-export
export const UPLOAD_FILE_BYTE = 31457280; // 30MiB
